module.exports = __webpack_public_path__ + "static/media/google_logo.0e031911.png";